export const environment = {
    production: false,
    baseUrl: 'https://test.crm.mojosoft.work/ws',
    userId: 'crm',
    password: 'MojoSoft123#@!test',
    appKey:"a383451512bd77ef1b45fd220341ac2c",
    assetsUrl:"https://test.crm.mojosoft.work/resources",
    version:"TEST 0.0.2",
    buildNo:202607041002,
  };
  
